// extracted by mini-css-extract-plugin
export default {"hamburger":"MenuHamburguer_hamburger__SM+IW"};